<template lang="pug">
.container
    .row
        .col-md-3

            .row
                .col-md-12
                    filter-sidebar(
                        :updateFilters="updateFilters"
                        :onAddAllChange="setAddAllMatch"
                    )

            .row
                .col-md-12.m-b-2.m-t-1
                    label Sizes

                    multiselect(
                        :options="sizes"
                        track-by="id"
                        label="name"
                        :showLabels="false"
                        v-model="setSelectedSize"
                    )

                .col-md-12.m-b-2
                    label.md-switch
                        input(
                            v-model="radioToggle"
                            type="checkbox"
                            :disabled="onLoading('generate-barcode')"
                            v-on:change="setToggle($event.target.checked)"
                        )
                        i.indigo
                        | {{ toggle ? 'Print' : 'Send Email to Retailers' }}

                .col-md-12.m-b-2
                    label.md-switch
                        input(
                            v-model="inactiveRadioToggle"
                            type="checkbox"
                            :disabled="onLoading('generate-barcode')"
                            v-on:change="setInactiveToggle($event.target.checked)"
                        )
                        i.indigo
                        | {{ inactiveToggle ? 'Exclude inactive product(s)' : 'Include inactive product(s)' }}

        .col-md-9
            .alert.alert-info
                template
                    span(v-html="getMessage(data, inactiveData, addAllMatching)")

            .alert.alert-danger(v-if="addAllMatching && !inactiveToggle")
                template
                    span You may have include any inactive products

            v-server-table(
                :url="url"
                :columns="columns"
                :options="tableOptions"
                :name="tableName"
                ref="datatable"
            )
                template(slot="beforeTable")
                    datatable-loader(:name="tableName")

                template(slot="select" slot-scope="props")
                    .text-center
                        label.md-check
                            input(
                                :disabled="addAllMatching"
                                type="checkbox"
                                :checked="checkedProducts(props.row)"
                                @change="onChange(props.row)"
                            )
                            i.indigo
</template>

<script>
const TableName = 'VUETABLE_SHELF_LABEL_PRODUCTS';

import filterSidebar from '../template/filter-sidebar.vue';
import { mapGetters, mapMutations } from 'vuex';
import dateMixin from '@js/mixins/date-format';
import formattedCurrencyMixin from '@js/mixins/formatted-currency';

export default {
    components: { filterSidebar },

    mixins: [dateMixin, formattedCurrencyMixin],

    data() {
        return {
            tableName: TableName,
            columns: ['select', 'name', 'code', 'unit_price', 'updated_at'],
        };
    },

    computed: {
        ...mapGetters('override_pricebook', ['pricebook']),

        ...mapGetters('shelfLabel', [
            'data',
            'toggle',
            'selectedSize',
            'sizes',
            'addAllMatching',
            'temporaryData',
            'inactiveData',
            'inactiveToggle',
        ]),

        setSelectedSize: {
            get() {
                return this.selectedSize;
            },

            set(value) {
                this.assignSelectedSize(value);
            },
        },

        url() {
            return Laroute.route(
                'franchise.inventory.override_pricebook.entries',
                {
                    id: this.pricebook.id,
                },
            );
        },

        tableOptions() {
            return {
                sortable: [],
                filterable: false,
                customFilters: ['recentProduct'],
                skin: 'table table-striped table-bordered m-b-0 b-b',
                initFilters: {
                    recentProduct: true,
                },
                templates: {
                    updated_at: (h, row) => {
                        return this.dateFormat(row.updated_at);
                    },
                    unit_price: (h, row) => {
                        return row.unit_price;
                    },
                },
                params: {
                    category_id: this.$parent.$parent.filters.category,
                    query: this.$parent.$parent.filters.search,
                    tag_ids: this.$parent.$parent.filters.tags.map(t => t.id),
                    shelf_space_plan_ids: this.$parent.$parent.filters.shelfSpacePlan.map(
                        t => t.id,
                    ),
                },
                headings: {
                    name: 'Product Name',
                    code: 'Barcode',
                    unit_price: `Unit Price (${this.getCurrency()})`,
                    updated_at: 'Recent Updated',
                    select: (h, row) => {
                        return require('../../pricebook/shelf-labels/heading-checkbox').call(
                            this,
                            h,
                            row,
                        );
                    },
                },
                columnsClasses: {
                    unit_price: 'text-right',
                    select: 'text-center',
                },
                responseAdapter: response => {
                    this.setTemporaryData(response.data.data);
                    this.setTemporaryDataCount(response.data.count);

                    return {
                        data: response.data.data,
                        count: response.data.count,
                    };
                },
            };
        },

        radioToggle: {
            get() {
                return this.toggle;
            },

            set(value) {
                this.setToggle(value);
            },
        },

        selectedAll() {
            let checkAll = this.temporaryData.map(data => {
                return this.data.map(p => p.id).includes(data.id);
            });

            let filterCheckAll = checkAll.filter(f => f === true);

            return filterCheckAll.length === this.temporaryData.length;
        },

        inactiveRadioToggle: {
            get() {
                return this.inactiveToggle;
            },

            set(value) {
                this.setInactiveToggle(value);
            },
        },
    },

    methods: {
        ...mapMutations('shelfLabel', [
            'assignProducts',
            'setToggle',
            'assignSelectedSize',
            'setAddAllMatching',
            'setTemporaryData',
            'setTemporaryDataCount',
            'unAssignProducts',
            'setInactiveToggle',
        ]),

        updateFilters(filters) {
            this.$parent.$parent.filters = filters;
            this.refreshFilters();
        },

        setAddAllMatch(addAll) {
            this.setAddAllMatching(addAll);
        },

        refreshFilters() {
            this.$nextTick(this.refreshProducts);
        },

        refreshProducts() {
            this.$refs.datatable.refresh();
        },

        checkedProducts(row) {
            if (this.data) {
                return this.data.map(p => p.id).includes(row.id);
            }
        },

        onChangeSelectAll(value) {
            if (value) {
                this.temporaryData.map(data => {
                    data.ignore = true;
                    this.assignProducts(data);
                });
            } else {
                this.temporaryData.map(data => {
                    this.unAssignProducts(data);
                });
            }
        },

        onChange(row) {
            row.ignore = false;
            this.assignProducts(row);
        },

        getMessage(data, inactiveData, addAllMatching) {
            if (addAllMatching) {
                return 'All matching products selected';
            } else if (data.length > 0) {
                let product = `${data.length} ${this.productWording(
                    data,
                )} selected.`;

                let inactiveProduct = `Detected <span class="text-danger">${inactiveData} inactive ${this.productWording(
                    inactiveData,
                )}</span> in the selection.`;

                if (inactiveData === 0) {
                    return product;
                }

                return `${product} ${inactiveProduct}`;
            } else {
                return 'No product selected';
            }
        },

        productWording(data) {
            return data.length === 1 || data === 1 ? 'product' : 'products';
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/override_pricebook/shelf-labels/shelf-labels-products.vue